import React from "react";
import RichText from "../richtext";
import { getFalconColorsClass } from "../../utils/utils";
import { NONE } from "../../utils/constants";
import {
  GenericSBProps,
  Alignment,
  Asset,
  FalconColorsTypes,
  NativeColorPicker,
  ComponentWithContentProps,
} from "../../components/types";

export interface FalconDescriptionInterface extends GenericSBProps {
  text: Array<Object>;
  textColor: FalconColorsTypes;
  textColorPicker: NativeColorPicker;
  icon: Asset;
  textElementPosition: Alignment;
}
const FalconDescription: React.FC<
  ComponentWithContentProps<FalconDescriptionInterface>
> = ({ content }) => {
  const titleStyle = getFalconColorsClass(content.textColor);

  return (
    <>
      <div
        className={`${"d-inline-flex"} align-${content.textElementPosition}`}
      >
        {content.icon && content.icon.filename && (
          <img
            src={content.icon && content.icon.filename}
            alt={content.icon && content.icon.alt}
            title={content.icon && content.icon.title}
            height={24}
            width={24}
          />
        )}
        {content.text && (
          <div
            className={`${content.icon && content.icon.filename} ${
              content.textColor && content.textColor != NONE ? titleStyle : ""
            }`}
            style={{
              ...(content.textColor && content.textColor === NONE
                ? { color: content.textColorPicker?.color }
                : {}),
            }}
          >
            <RichText content={content.text} />
          </div>
        )}
      </div>
    </>
  );
};

export default FalconDescription;
